import { QueryClient } from 'react-query';

/**
 * App-wide React Query client. Lives in its own module so logout (Layout) and the
 * 401 interceptor (api.js) can clear personalized caches without importing App.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default queryClient;
